const projectPathMeta = document.querySelector('meta[name="herb-project-path"]')

if (projectPathMeta) {
  void loadHerbDevTools(projectPathMeta.content)
}

async function loadHerbDevTools(projectPath) {
  const { HerbDevTools } = await import("@herb-tools/dev-tools")
  const host = window.location.hostname || "localhost"

  HerbDevTools.start({
    devServer: {
      host,
      port: 8592,
    },
    projectPath,
  })
}
